import * as $ from 'jquery';
import * as ko from 'knockout';

declare var DobryKantor: any;
declare var CANTORVERSION: any;
declare var BACKENDPATH: any;

export class CurrencyCalculatorComponent {
    operation: ko.Observable<string>;
    amount: ko.Observable<number>;
    currency: ko.Observable<string>;
    rebate: ko.Observable<string>;
    seconds: ko.Observable<number>;
    rates: ko.Observable<any[]>;
    costs: ko.Observable<any[]>;
    rate: ko.Observable<number>;
    currencies: ko.ObservableArray<any>;
    walletDepositMode: ko.Observable<boolean>;
    panelLink: ko.Computed<string>;
    hideHeader: ko.Observable<boolean>;

    currencyRate: ko.Computed<number>;
    currencyRateAfterRebate: ko.Computed<number>;
    currencyRateAverage: ko.Computed<number>;
    currencyRateBank: ko.Computed<number>;
    currencyRateEntry: ko.Computed<any>;
    currencyEntry: ko.Computed<any>;
    currencyCostEntry: ko.Computed<any>;
    currencyCost: ko.Computed<any>;
    yourPayment: ko.Computed<any>;
    yourSavings: ko.Computed<any>;
    yourPaymentText: ko.Computed<any>;
    yourSavingsText: ko.Computed<any>;
    isSale: ko.Computed<boolean>;
    showRabate: ko.Computed<boolean>;
    rebates: any[];

    reloadTime: number = 15;
    private timeoutid: number;

    startTimer() {
        return window.setTimeout(() => {
            if (this.seconds() == 0) {
                this.getCurrencyRates();
                this.getCurrencyCosts();
                this.seconds(this.reloadTime);
            } else {
                this.seconds(this.seconds() - 1);
            }

            this.timeoutid = this.startTimer();
        }, 1000);
    }

    getCurrencyRates() {
        return $.ajax({
            url: BACKENDPATH + '/api/currency/rates',
            xhrFields: {
                withCredentials: false
            },
            method: 'GET'
        }).then((result) => {
            this.rates(result.data);
        });
    }

    getCurrencyCosts() {
        return $.getJSON(BACKENDPATH + '/api/currency/costs').then((result) => {
            this.costs(result.data);
        });
    }

    dispose() {
        clearTimeout(this.timeoutid);
    }

    constructor(params) {
        params = params || {};

        params.walletDepositMode = params.walletDepositMode || false;
        params.hideHeader = params.hideHeader || false;

        this.rebates = [
            { Text: "0%", Value: "0" },
            { Text: "10%", Value: "10" },
            { Text: "20%", Value: "20" },
            { Text: "30%", Value: "30" },
            { Text: "40%", Value: "40" },
            { Text: "50%", Value: "50" },
            { Text: "60%", Value: "60" },
            { Text: "70%", Value: "70" },
            { Text: "80%", Value: "80" },
            { Text: "90%", Value: "90" },
            { Text: "100%", Value: "100" }
        ];
        if (typeof DobryKantor !== 'undefined') {
            this.rates = ko.observable(DobryKantor.params.currencyRates ?? []);
        } else {
            this.rates = ko.observable([]);
        }
        this.costs = ko.observable([]);
        this.getCurrencyCosts();

        this.seconds = ko.observable(0);

        this.operation = ko.observable(params.operation || "1");
        this.amount = ko.observable(1000);
        this.currency = ko.observable(null);

        let basicRate = "20";
        switch (CANTORVERSION) {
            case "expert":
                basicRate = "0";
                break;
            case "nordiqa":
                basicRate = "10";
                break;
            case "doradcyfirmy":
                basicRate = "20";
                break;
            default:
                basicRate = "20";
                break;
        }

        this.rebate = ko.observable(params.walletDepositMode ? "0" : basicRate);
        this.currencies = ko.observableArray([]);
        this.rate = ko.observable(null);

        this.walletDepositMode = ko.observable(params.walletDepositMode);

        this.currencyRateEntry = ko.computed(() => {
            for (let i = 0; i < this.rates().length; i++) {
                let rate = this.rates()[i];

                if (rate.Symbol === this.currency()) {
                    return rate;
                }
            }
        });

        this.currencyEntry = ko.computed(() => {
            for (let i = 0; i < this.currencies().length; i++) {
                let curr = this.currencies()[i];

                if (curr.Symbol === this.currency()) {
                    return curr;
                }
            }
        });

        this.currencyRate = ko.computed(() => {
            let currencyRateEntry = this.currencyRateEntry();

            if (currencyRateEntry) {
                if (this.operation() === "1") {
                    return currencyRateEntry.Buy;
                }

                if (this.operation() === "2") {
                    return currencyRateEntry.Sale;
                }
            }

            return null;
        });

        this.currencyCostEntry = ko.computed(() => {
            for (let i = 0; i < this.costs().length; i++) {
                let cost = this.costs()[i];

                if (cost.Symbol === this.currency()) {
                    return cost;
                }
            }
        });

        this.currencyCost = ko.computed(() => {
            let currencyCostEntry = this.currencyCostEntry();

            if (currencyCostEntry) {
                if (this.operation() === "1") {
                    return currencyCostEntry.Buy;
                }

                if (this.operation() === "2") {
                    return currencyCostEntry.Sale;
                }
            }

            return null;
        });

        this.currencyRateAverage = ko.computed(() => {
            let currencyRateEntry = this.currencyRateEntry();

            if (currencyRateEntry) {
                return (currencyRateEntry.Sale + currencyRateEntry.Buy) / 2;
            }

            return null;
        });

        this.currencyRateBank = ko.computed(() => {
            let currencyRateEntry = this.currencyRateEntry();

            if (currencyRateEntry) {
                if (this.operation() === "1") {
                    return (currencyRateEntry.Buy + currencyRateEntry.Sale) * 0.475;
                }

                if (this.operation() === "2") {
                    return (currencyRateEntry.Buy + currencyRateEntry.Sale) * 0.525;
                }
            }

            return null;
        });


        this.currencyRateAfterRebate = ko.computed(() => {
            
            var op = this.operation() === "1"? 1 /*sell*/ : -1 /*buy*/;
            var rate = this.currencyRate() 
                - ((this.currencyRate() - this.currencyRateAverage() + op * this.currencyCost())* (parseInt(this.rebate()) / 100));
            return Math.round(rate * 10000) / 10000;
        });

        this.yourPayment = ko.computed(() => {
            let currencyRateEntry = this.currencyRateEntry();

            if (currencyRateEntry) {
                let averageRate = (currencyRateEntry.Sale + currencyRateEntry.Buy) / 2;

                return Math.round((this.amount() * this.currencyRateAfterRebate() / currencyRateEntry.Multiplier) * 100) / 100;
            }

            return null;
        });

        this.yourSavings = ko.computed(() => {
            let currencyRateEntry = this.currencyRateEntry();

            if (currencyRateEntry) {
                return Math.round(Math.abs(this.currencyRateBank() * this.amount() / currencyRateEntry.Multiplier - this.yourPayment()) * 100) / 100;
            }

            return null;
        });

        this.yourPaymentText = ko.computed(() => {
            return this.yourPayment() + ' PLN';
        });

        this.yourSavingsText = ko.computed(() => {
            return this.yourSavings() + ' PLN';
        });

        this.isSale = ko.computed(() => {
            return this.operation() === "1";
        });

        this.showRabate = ko.computed(() => {
            return CANTORVERSION !== "expert";
        });

        $.get(BACKENDPATH + '/api/dictionary/currencies?noPLN=1').then((result) => {
            this.currencies(result.data);
            this.currency(DobryKantor.params.currentCurrency);
        });

        this.timeoutid = this.startTimer();

        this.panelLink = ko.computed(() => {
            if (this.currency) {
                if (this.operation() === "1") {
                    return `/panel-klienta/wymiana.html;currencyId=${this.currency()};amount=${this.amount()}`;
                }

                if (this.operation() === "2") {
                    return `/panel-klienta/wymiana.html;currencyToId=${this.currency()};amount=${this.amount()}`;
                }
            }

            return "";
        });

        this.hideHeader = ko.observable(params.hideHeader);
    }

    submit() {
        return false;
    }
}
